import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellowcalf.css/Fee_Due_for_Siblings.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { formatNumber } from "../../utils/formatNumber";

function Fee_Due_for_Siblings() {
  // 1. State Hooks
  const [siblingData, setSiblingData] = useState([]);
  const [parents, setParents] = useState([]); // State for dropdown
  const [loading, setLoading] = useState(false);
  const [selectedParent, setSelectedParent] = useState("");

  // 2. Fetch Logic
  const fetchInitialData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: localStorage.getItem("user_id") || 14857,
        id: selectedParent, // Sending the selected parent user_id
      };

      // Using the endpoint from your provided code
      const response = await simplePostCall(
        ApiConfig.siblingsreportsReport,
        JSON.stringify(payload),
      );

      if (response && response.result) {
        // Update the table data
        setSiblingData(response.data || []);

        // Update the parents list for the dropdown if it's the first load
        if (response.parents_list && parents.length === 0) {
          setParents(response.parents_list);
        }
      }
    } catch (error) {
      console.error("Error fetching sibling report:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedParent, parents.length]);

  // Initial Load
  useEffect(() => {
    fetchInitialData();
  }, [selectedParent]); // Only runs once to populate initial data/dropdown

  return (
    <div className="fee-due-container" style={{ paddingTop: "25px" }}>
      <div className="fee-due-header">
        <h3>Fee Due for Siblings</h3>
        <div className="export-btn-container">
          <button className="export-btn-siblings">
            Export <span className="arrow-down"></span>
          </button>
        </div>
      </div>

      <div className="fee-due-body">
        {/* Filter Section */}
        <div className="filter-section">
          <select
            className="parent-select"
            value={selectedParent}
            onChange={(e) => setSelectedParent(e.target.value)}
          >
            <option value="">Select Parent</option>
            {parents.map((parent) => (
              <option key={parent.user_id} value={parent.user_id}>
                {parent.user_name} (ID: {parent.user_id})
              </option>
            ))}
          </select>
          <button
            className="search-btn-fee"
            onClick={fetchInitialData}
            disabled={loading}
          >
            {loading ? "Searching..." : "Search"}
          </button>
        </div>

        {/* Table Section */}
        <div className="table-container">
          <table className="fee-table">
            <thead>
              <tr>
                <th>Sr No</th>
                <th>Student Name</th>
                <th>Grade</th>
                <th>Division</th>
                <th>Total Amount</th>
                <th>Balance</th>
              </tr>
            </thead>
            <tbody>
              {siblingData.length > 0 ? (
                siblingData.map((item, index) => (
                  <tr key={item.student_id || index}>
                    <td>{index + 1}</td>
                    <td>{item.student_name}</td>
                    <td>{item.class_name}</td>
                    <td>{item.class_division_name}</td>
                    <td>{formatNumber(item.total_amount)}</td>
                    <td
                      style={{
                        color:
                          item.balance === 0 || item.balance === "0"
                            ? "green"
                            : "red",
                        fontWeight: "bold",
                      }}
                    >
                      {item.balance}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="no-results text-center">
                    {loading ? (
                      <div className="d-flex justify-content-center">
                        <ScaleLoader color="#F4BB44" height={25} />
                      </div>
                    ) : (
                      "No results found for this parent."
                    )}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Fee_Due_for_Siblings;
